module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading === 1) ? _c('loading', {
    staticStyle: {
      "min-height": "620px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }]
  }, [(_vm.evaluate_result.abilities && _vm.evaluate_result.abilities.length > 0) ? _c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "m-b-sm"
  }, [(_vm.questionnaire.category === 2) ? _c('span', [_vm._v("岗位")]) : _vm._e(), _vm._v("测评报告\n        "), (_vm.questionnaire.category === 2) ? _c('span', {
    staticClass: "btn btn-primary right",
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("下载报告")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "report-area"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "p-t-b-md n-m-b text-center"
  }, [_vm._v(_vm._s(_vm.questionnaire.category === 1 ? '个人' : '岗位') + "测评报告")])]), _vm._v(" "), (_vm.questionnaire.category === 2) ? _c('div', {
    staticClass: "row user-info p-b-sm snapshort"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.realname ? _vm.tester.realname : _vm.tester.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("邮箱:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.email))])]), _vm._v(" "), (_vm.tester.phone) ? _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.phone))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("岗位:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.questionnaire.alias ? _vm.questionnaire.alias : _vm.questionnaire.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.tester.avatar) ? _c('img', {
    staticClass: "m-r-sm right",
    attrs: {
      "src": _vm.tester.avatar,
      "alt": "",
      "width": "100"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-tb-sm "
  })]), _vm._v(" "), (_vm.evaluate_result.abilities && _vm.evaluate_result.abilities.length >= 3) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('radar', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "title": _vm.radar_data.title,
      "legend": _vm.radar_data.legend,
      "series": _vm.radar_data.series,
      "indicator": _vm.radar_data.indicator
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm "
  })], 1) : _vm._e(), _vm._v(" "), (_vm.evaluate_result.abilities && _vm.evaluate_result.abilities.length >= 3) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "bar-area"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm "
  })]) : _vm._e(), _vm._v(" "), (_vm.questionnaire.category === 2) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('time-scatter', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "code": _vm.code,
      "type": 3,
      "name": _vm.evaluate_result.name,
      "score": _vm.evaluate_result.duration
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm "
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail_data === 0),
      expression: "detail_data === 0"
    }],
    staticClass: "row"
  }, _vm._l((_vm.evaluate_result.abilities), function(ability, ind) {
    return _c('div', {
      key: ability._id,
      staticClass: "col-xs-12 m-b-sm ability snapshort",
      class: {
        'open': ability.is_open === 1
      },
      attrs: {
        "data-index": ind
      }
    }, [_c('div', {
      staticClass: "btn btn-md n-b-r col-xs-12 n-f btn-success"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3 col-xs-12"
    }, [_c('span', [_vm._v("能力名称：")]), _vm._v(" "), _c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(ability.ability.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "detail col-xs-12"
    }, [_c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [_c('div', {
      staticClass: "row p-l-r-xs"
    }, [_c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.ability.desc)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('Scatter', {
      staticClass: "col-xs-12 n-p-l n-p-r",
      staticStyle: {
        "height": "200px"
      },
      attrs: {
        "code": _vm.code,
        "type": 2,
        "target": ability.ability._id,
        "name": ability.ability.name,
        "score": ability.score,
        "rate": ability.rate
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s(ability.score.toFixed(2)) + "分")]), _vm._v(",领先\n                        "), _c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s((ability.rate * 100).toFixed(2)) + "%")]), _vm._v("的" + _vm._s(_vm.questionnaire.category === 1 ? '用户' : '求职者'))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [(ability.grade_desc) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("解析：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_desc)
      }
    })])]) : _vm._e(), _vm._v(" "), (ability.grade_suggestion) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("建议：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_suggestion)
      }
    })])]) : _vm._e(), _vm._v(" "), (ability.grade_improvement) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("提升：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_improvement)
      }
    })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "b-b m-b-xs"
    }), _vm._v(" "), (ability.indicators.length >= 3) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('radar', {
      staticClass: "col-xs-12",
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "title": ability.radar_data.title,
        "legend": ability.radar_data.legend,
        "series": ability.radar_data.series,
        "indicator": ability.radar_data.indicator
      }
    })], 1) : _vm._e(), _vm._v(" "), (ability.indicators.length >= 3) ? _c('div', {
      staticClass: "b-b m-b-xs"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((ability.indicators), function(indicator) {
      return _c('div', {
        key: indicator._id,
        staticClass: "indicator col-xs-12",
        class: {
          'col-sm-4': ability.indicators.length >= 3, 'col-sm-6': ability.indicators.length <= 2
        }
      }, [_c('Scatter', {
        staticClass: "col-xs-12 n-p-l n-p-r",
        staticStyle: {
          "height": "200px"
        },
        attrs: {
          "code": _vm.code,
          "type": 1,
          "target": indicator.indicator._id,
          "name": indicator.indicator.name,
          "score": indicator.score,
          "rate": indicator.rate
        }
      }), _vm._v(" "), (_vm.questionnaire.category === 2) ? _c('time-scatter', {
        staticClass: "col-xs-12 n-p-l n-p-r",
        staticStyle: {
          "height": "200px"
        },
        attrs: {
          "code": _vm.code,
          "type": 1,
          "target": indicator.indicator._id,
          "name": indicator.indicator.name,
          "score": indicator.duration,
          "rate": indicator.rate
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
        staticStyle: {
          "font-size": "14px"
        }
      }, [_c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s(indicator.score.toFixed(2)) + "分")]), _vm._v(",领先\n                        "), _c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s((indicator.rate * 100).toFixed(2)) + "%")]), _vm._v("的" + _vm._s(_vm.questionnaire.category === 1 ? '用户' : '求职者'))]), _vm._v(" "), (indicator.grade_desc) ? _c('div', {
        staticClass: " p-t-b-sm"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "label m-b-xs"
      }, [_vm._v("指标解析：")]), _vm._v(" "), _c('div', {
        staticClass: "desc",
        domProps: {
          "innerHTML": _vm._s(indicator.grade_desc)
        }
      })])])]) : _vm._e()], 1)
    }))])])])
  })), _vm._v(" "), _vm._m(2)])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-t-b-sm"
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "background": "#42b983"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "psych-logo left",
    attrs: {
      "src": "/assets/images/psych2_4_2.jpg",
      "alt": "",
      "height": "60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "lechenggu-logo left right",
    attrs: {
      "src": "/assets/images/lechenggu-logo.png",
      "alt": "",
      "height": "60"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("本报告由")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所·心理健康应用中心",
      "alt": "中国科学院心理研究所·心理健康应用中心"
    }
  }, [_vm._v("中国科学院心理研究所·心理健康应用中心")]), _vm._v(" "), _c('span', [_vm._v("提供测评技术支持")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7700b2ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/report/normal.vue
// module id = 493
// module chunks = 1